
export const formatDate = (date) => {
    if(!date.includes('T')) {
        return date;
    }
    if(!date) return '-'
    const d = new Date(date);
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const day = d.getDate().toString().padStart(2, "0");
    const year = d.getFullYear().toString();
    return [year, month, day].join("-");
};